// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Nunito Sans', 'Nunito Sans Fallback'","fontStyle":"normal"},"className":"__className_ad9d8d","variable":"__variable_ad9d8d"};